module.exports = __webpack_public_path__ + "media/images/jobs/jobs-influencer-zh-hant-5d6f88b7a15110a17efdd195a8fffbf1.jpg";